import { jsx, jsxs } from "react/jsx-runtime";
import "react";
const SvgRewards = (props)=>/*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        "aria-hidden": "true",
        viewBox: "0 0 48 48",
        ...props,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "#fff",
                d: "M6.008 21.924h14.486v-7.392h6.16v7.392h14.368c.925 0 1.8-.627 1.949-1.552.02-.11.029-.23.029-.339v-4.048c0-1.194-.974-2.179-2.155-2.179H6.155c-1.18 0-2.155.985-2.155 2.179v4.068c.01 1.055.955 1.86 1.998 1.86zM26.654 24.53v20.313h11.593c1.18 0 2.155-.984 2.155-2.178V24.53zM20.494 24.53H6.608v18.135c0 1.194.974 2.178 2.155 2.178h11.73z"
            }),
            /*#__PURE__*/ jsx("path", {
                stroke: "#000",
                strokeMiterlimit: 10,
                strokeWidth: 1.35,
                d: "M24.204 13.796H14.067c-2.804 0-5.087-2.308-5.087-5.143s2.283-5.143 5.087-5.143c2.5 0 7.056 5.989 8.907 8.565l1.24 1.731z"
            }),
            /*#__PURE__*/ jsx("path", {
                stroke: "#000",
                strokeMiterlimit: 10,
                strokeWidth: 1.35,
                d: "M32.992 13.796H22.855l1.24-1.73c1.84-2.577 6.407-8.566 8.907-8.566 2.804 0 5.087 2.308 5.087 5.143s-2.283 5.143-5.087 5.143zM6.008 21.924h14.486v-7.392h6.16v7.392h14.368c.925 0 1.8-.627 1.949-1.552.02-.11.029-.23.029-.339v-4.048c0-1.194-.974-2.179-2.155-2.179H6.155c-1.18 0-2.155.985-2.155 2.179v4.068c.01 1.055.955 1.86 1.998 1.86zM26.654 24.53v20.313h11.593c1.18 0 2.155-.984 2.155-2.178V24.53zM20.494 24.53H6.608v18.135c0 1.194.974 2.178 2.155 2.178h11.73z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#000",
                d: "m41.052 22.49-35.113.08v1.78l35.113-.089z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#000",
                d: "M26.625 14.124h-6.692V45.5h6.692z"
            })
        ]
    });
const Rewards = SvgRewards;
export { Rewards as default };
